import db from "../utils/firestore";
import { IACLEmail, IAppointmentHistory } from "intake_shared/src/types";
import { Collection } from "intake_shared/src/enum";
import { uniqBy } from "lodash";

function convertDataToAcl(acl_doc: any): IACLEmail {
    if (acl_doc.exists) {
        const acl_doc_data = acl_doc.data();
        if (!acl_doc_data) {
            return {} as IACLEmail;
        }
        const {
            email,
            acl,
            deleted,
            deleted_at,
            deleted_by,
            assignment_color = "",
            assignment,
        } = acl_doc_data;

        return {
            email,
            acl,
            deleted,
            deleted_at,
            deleted_by,
            assignment_color,
            assignment,
        };
    }
    return {} as IACLEmail;
}

export async function getAClByEmail(email: string): Promise<IACLEmail | undefined> {
    const acl_doc = await db.collection(Collection.ACL).doc(email).get();
    return convertDataToAcl(acl_doc);
}

export async function getAllACL(): Promise<IACLEmail[] | undefined> {
    const acl_docs = await db.collection(Collection.ACL).get();

    let data = acl_docs.docs.map(convertDataToAcl);

    data = data.filter((d) => !Boolean(d?.deleted));

    return data;
}

export async function getCareCoordinatorACL(): Promise<IACLEmail[]> {
    const snapshot = await db
        .collection(Collection.ACL)
        .where("acl.care_coordinator", "==", true)
        .get();
    return snapshot.docs.map(convertDataToAcl).filter((user) => !user.deleted);
}

export async function saveAcl(emailAcl: IACLEmail) {
    await db
        .collection(Collection.ACL)
        .doc(emailAcl.email)
        .set({ ...emailAcl }, { merge: true });
}

export const fetchUserAcls = async (
    histories: IAppointmentHistory[],
    knownAcls: IACLEmail[] = []
): Promise<{ [email: string]: IACLEmail | undefined }> => {
    const aclData: { [email: string]: IACLEmail | undefined } = {};
    const uniqueEmails = uniqBy(histories, "cancelled_by")
        .filter((r) => r.cancelled_by)
        .map((r) => r.cancelled_by);

    // App start already loads every non-deleted ACL; only read the ones it
    // does not have (e.g. deleted users) instead of one read per canceller.
    const knownByEmail = new Map(knownAcls.map((acl) => [acl.email, acl]));
    for (const email of uniqueEmails) {
        const known = knownByEmail.get(email as string);
        if (known) {
            aclData[email as string] = known;
            continue;
        }
        try {
            const aclResponse = await getAClByEmail(email as string);
            aclData[email as string] = aclResponse || undefined;
        } catch (error) {
            console.error(`Error fetching ACL for ${email}:`, error);
        }
    }

    return aclData;
};
